module.exports = __webpack_public_path__ + "img/avatar7.a871c692.png";